import { CommonDateRange } from 'components';
import React, { useContext, useEffect, useState } from 'react'
import { BsDownload } from 'react-icons/bs';
import { FiRefreshCcw } from 'react-icons/fi';
import moment from 'moment';
import { getJournalReport } from '_services/reportService/reportService';
import StorageService from 'utils/StorageServices/StorageServices';
import { utils } from 'helper';
import { Link } from 'react-router-dom';
import { UserContext } from 'context';

const JournalReport = () => {

  const { generalLedgerDate, setGeneralLedgerDate } = useContext(UserContext);
  const [journalReportData, setJournalReportData] = useState({});
  const [loading, setLoading] = useState(false);
  const currentDate = new Date();
  const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
  const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

  const [selectedRange, setSelectedRange] = useState({
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month'),
  });

  const handleApply = (newRange) => {
    setSelectedRange(newRange);
    setGeneralLedgerDate(newRange)
  };

  useEffect(() => {
    getJournalReportList()
  }, [selectedRange])

  const getJournalReportList = async () => {
    setLoading(true)
    const payload = {
      company_id: StorageService.getCompanyId(),
      start_date: moment(selectedRange.startDate).format("YYYY-MM-DD"),
      end_date: moment(selectedRange.endDate).format("YYYY-MM-DD"),
    }
    try {
      const res = await getJournalReport(payload);
      if (res?.responseCode == 200) {
        setJournalReportData(res?.data)
        setLoading(false)
      } else {
        setLoading(false)
      }
    } catch (error) {
      setLoading(false);
    }
  }

  const resetFunction = () => {
    const newStartDate = moment().startOf('month');
    const newEndDate = moment().endOf('month');

    setSelectedRange({
      startDate: newStartDate,
      endDate: newEndDate,
    });
    setGeneralLedgerDate({
      startDate: newStartDate,
      endDate: newEndDate,
    });
  };

  return (
    <div className='__znDe_mainBx'>
      <div>
        <div className='panel-heading'>
          <h2><span> Journal Report </span></h2>

          <div className='panel-ctrls report-control'>
            <div>
              <CommonDateRange
                key={`${selectedRange.startDate}-${selectedRange.endDate}`}
                initialStartDate={selectedRange.startDate}
                initialEndDate={selectedRange.endDate}
                onApply={handleApply}
              />
            </div>

            <button className='__bxs_srBtn'>
              <BsDownload />
            </button>

            <button className='__bxs_srBtn' onClick={(e) => resetFunction(e)}>
              <FiRefreshCcw />
            </button>
          </div>
        </div>
      </div>

      <div className='__hrlMain_dix'>
        {/* <div className='voucher report-voucher  printable ng-table-reports __glDetailsBx'> */}
        <div className='voucher report-voucher  printable ng-table-reports'>
          <div className='__mainPanel'>
            <div className="panel panel-primary">
              <div className='panel-body '>
                <div className='py-20 block-ui block-ui-anim-fade' style={{ paddingBottom: '0px' }}>
                  <div className='clear-both text-center p-10'>
                    <div className="__hrlMx_head" >
                      <p>{journalReportData?.company?.company ? journalReportData?.company?.company : '-'}</p>
                      <h4>Journal Report</h4>
                      {/* <h5><span>Basis</span> Accrual</h5> */}
                      <h5>From <span> {journalReportData?.start_date ? utils.getDateByApiResponse(journalReportData?.start_date) : ""} </span>  To <span> {journalReportData?.end_date ? utils.getDateByApiResponse(journalReportData?.end_date) : ""} </span></h5>
                    </div>
                  </div>
                  {loading ? <span className='m-5 commonCenter_avt'> Loading... </span> : (journalReportData?.list?.length > 0 ?
                    journalReportData?.list?.map((listItem, listIndex) => {
                      return (
                        <div className='clear-both' key={listIndex}>
                          <div className='report-table w-100'>
                            {listItem?.vendors?.map((vendorItem, venderIndex) => {
                              return (
                                <table className='table report-table w-100 table-hover ng-table' key={venderIndex}>
                                  <thead>
                                    <tr className='ng-table-sort-header'>
                                      <th className='header text-left'>
                                        <div className='ng-table-header'>
                                          <span>{journalReportData?.start_date ? utils.getDateByApiResponse(journalReportData?.start_date) : ""} - {listItem?.sub_type_name ? `${listItem?.sub_type_name} ${listItem?.type_name ? `| ${listItem?.type_name}` : ''}` : listItem?.type_name} {vendorItem?.vendor_name ? `(${vendorItem?.vendor_name})` : ''} </span>
                                        </div>
                                      </th>

                                      <th className='header text-end pr-important-10' style={{ width: '20%' }}>
                                        <div className='ng-table-header'>
                                          <span>Debit (₹) </span>
                                        </div>
                                      </th>

                                      <th className='header text-end pr-important-10' style={{ width: '20%' }}>
                                        <div className='ng-table-header'>
                                          <span>Credit (₹) </span>
                                        </div>
                                      </th>

                                    </tr>
                                  </thead>

                                  <tbody>
                                    {vendorItem?.accounts?.map((items, itemIdex) => {
                                      return (
                                        <React.Fragment key={itemIdex}>
                                          <tr className='ledger in ledgers cursor-pointer' >
                                            <td className='text-left'>{items?.account?.name ? items?.account?.name : '-'}	</td>
                                            <td className='text-end'><Link to={`/report/general_ledger/general_ledger_details/${items?.account?._id}`}>{items?.total_debit ? items?.total_debit.toFixed(2) : 0}</Link></td>
                                            <td className='text-end'><Link to={`/report/general_ledger/general_ledger_details/${items?.account?._id}`}>{items?.total_credit ? items?.total_credit.toFixed(2) : 0}</Link></td>
                                          </tr>
                                        </React.Fragment>
                                      )
                                    })
                                    }
                                    <tr class="hover-muted f15 row-total">
                                      <td class="text-left"></td>
                                      <td class="text-end">{utils.getTotalAmount(vendorItem?.accounts, 'total_debit')}</td>
                                      <td class="text-end">{utils.getTotalAmount(vendorItem?.accounts, 'total_credit')}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              )
                            })}
                          </div>
                        </div>
                      )
                    }) : <span className='m-5'> No data found </span>)
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* {accountTransactionsData?.list?.length > 0 && <div className='paginationFt_avt'>
          <CustomPagination
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            currentPage={filter.offset}
            onPageChange={handlePageChange}
          />
        </div>} */}

    </div>
  )
}

export default JournalReport